<div class="icon" *ngIf="(icon || sparksAnimation) && showIcon">
  <ng-content select="rt-icon, rt-sparks-animation"></ng-content>
</div>

<div class="text-content">
  <ng-content></ng-content>
</div>

<div class="icon-help" *ngIf="iconHelp">
  <ng-content select="rt-icon-help"></ng-content>
</div>

<div class="badge" *ngIf="badge">
  <ng-content select="rt-badge"></ng-content>
</div>
